const styles = {
  tableCell: {
    width: 50,
  },
};

export default styles;
